import { Link, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import type { ReactNode } from 'react';
import React from 'react';

import {
  TXTWCL_Click_XhomeXhereX_homeX_to_go__ELL,
  TXTWCL_OopsX_Page_not_found
} from './PageNotFound.messages.json';
import styles from './PageNotFound.scss';

export interface Props {
  isModal?: boolean;
}

const PageNotFound: React.FC<Props> = ({ isModal }) => (
  <div className={classNames(styles.noGames, isModal && styles.modal)}>
    <div className={styles.infoBackground} />
    <div className={styles.pageNotFoundText}>
      <div className={classNames(styles.oopsMessage, isModal && styles.modal)}>
        <Translation {...TXTWCL_OopsX_Page_not_found} />
      </div>
      {!isModal && (
        <div className={styles.returnToMainPage}>
          <Translation
            {...TXTWCL_Click_XhomeXhereX_homeX_to_go__ELL}
            values={{ home: (msg: ReactNode) => <Link alias="home">{msg}</Link> }}
          />
        </div>
      )}
    </div>
  </div>
);

export default PageNotFound;
